import { Dialog, DialogContent, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { SearchContextProvider } from "@backstage/plugin-search-react";
import { Content, Page } from "@backstage/core-components";
import { searchPage } from "../../search/SearchPage";
import { useRootStyles } from "../styles/useRootStyles";

interface SearchDialogProps {
  open: boolean;
  onClose: () => void;
}

export const SearchDialog = ({ open, onClose }: SearchDialogProps) => {
  const classes = useRootStyles();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.searchDialog}
      maxWidth={false}
    >
      <DialogContent className={classes.searchDialogContent}>
        <IconButton
          className={classes.searchCloseButton}
          onClick={onClose}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>
        <SearchContextProvider>
          <Page themeId="home">
            <Content>{searchPage}</Content>
          </Page>
        </SearchContextProvider>
      </DialogContent>
    </Dialog>
  );
};
